import CrudTable from '../../components/CrudTable';
import { formatVND } from '../../lib/format';

// QT#3: hàng tồn đang bán = cột stock_quantity, sửa trực tiếp tại đây.
export default function ProductsAdmin() {
  return (
    <CrudTable
      title="📦 Sản phẩm & tồn kho"
      table="products"
      defaults={{ active: true, stock_quantity: 0 }}
      columns={[
        { key: 'name', label: 'Tên (VI)', type: 'text', required: true },
        { key: 'name_en', label: 'Tên (EN)', type: 'text', inTable: false },
        { key: 'category', label: 'Danh mục', type: 'text' },
        { key: 'category_en', label: 'Danh mục (EN)', type: 'text', inTable: false },
        { key: 'description', label: 'Mô tả (VI)', type: 'textarea', inTable: false },
        { key: 'description_en', label: 'Mô tả (EN)', type: 'textarea', inTable: false },
        { key: 'price', label: 'Giá', type: 'number', required: true, render: (r) => formatVND(r.price) },
        { key: 'sale_price', label: 'Giá sale', type: 'number', render: (r) => (r.sale_price ? formatVND(r.sale_price) : '—') },
        { key: 'stock_quantity', label: 'Tồn kho', type: 'number', render: (r) => (
            <strong style={{ color: r.stock_quantity < 20 ? 'var(--red)' : 'var(--ink)' }}>{r.stock_quantity}</strong>
          ) },
        { key: 'image_url', label: 'Ảnh (URL)', type: 'text', inTable: false },
        { key: 'is_hot_seasonal', label: 'Hot theo mùa', type: 'checkbox' },
        { key: 'is_best_seller', label: 'Best seller', type: 'checkbox' },
        { key: 'is_limited', label: 'Limited season', type: 'checkbox' },
        { key: 'is_favorite', label: 'LiNT favorite', type: 'checkbox' },
        { key: 'active', label: 'Đang bán', type: 'checkbox' },
      ]}
    />
  );
}
